namespace TabAurous.Stock {
    export class totalSaleschartPanelOptions {
        items: Sales.SalesMasterRow[];
    }

    export class totalSaleschartPanel extends Serenity.TemplatedPanel<totalSaleschartPanelOptions> {
        constructor(container: JQuery, opt: totalSaleschartPanelOptions) {
            super(container, opt);
            var items = opt.items;
            var months = [''];
            months.pop()
            var grosssales = [0];
            grosssales.pop();
            var totalsales = 0;
            for (var i = 0; i < opt.items.length; i++) {
                if (months.length < 10) {
                    months.push(items[i].Month);
                    grosssales.push(items[i].MonthlySales);
                    totalsales += items[i].MonthlySales;
                }
            }
            var options = {
                series: [{
                    name: 'Total Sales ' + totalsales,
                    data: grosssales
                }],
                chart: {
                    height: 350,
                    type: 'bar',
                },
                plotOptions: {
                    bar: {
                        borderRadius: 10,
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val + "%";
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },

                xaxis: {
                    categories: months,
                    position: 'bottom',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                        formatter: function (val) {
                            return val + "%";
                        }
                    }

                },
                title: {
                    text: 'Total Sales ' + totalsales,
                    floating: true,
                    offsetY: 330,
                    align: 'center',
                    style: {
                        color: '#444'
                    }
                }
            };


            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);
            chart.render();

        }

        getTemplate() {
            return `<div class="~_totalSalesContainer"  style="height:300px;  width:450px;" ></div>`;
        }
    }

    export class topProductchartPanelOptions {
        items: Sales.SalesItemsRow[];
    }

    export class topProductchartPanel extends Serenity.TemplatedPanel<topProductchartPanelOptions> {
        constructor(container: JQuery, opt: topProductchartPanelOptions) {
            super(container, opt);
            var items = opt.items;
            var products = [];
            var grosssales = [0];
            grosssales.pop();
            for (var i = 0; i < opt.items.length; i++) {
                if (products.length < 10) {
                    products.push(opt.items[i].ProductCode);
                    grosssales.push(items[i].GrossAmountPercent);
                }
            }
            var options = {
                series: [{
                    data: grosssales
                }],
                chart: {
                    type: 'bar',
                    height: 380
                },
                plotOptions: {
                    bar: {
                        barHeight: '100%',
                        distributed: true,
                        horizontal: true,
                        dataLabels: {
                            position: 'bottom'
                        },
                    }
                },
                colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
                    '#f48024', '#69d2e7'
                ],
                dataLabels: {
                    enabled: true,
                    textAnchor: 'start',
                    style: {
                        colors: ['#fff']
                    },
                    formatter: function (val, opt) {
                        return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
                    },
                    offsetX: 0,
                    dropShadow: {
                        enabled: true
                    }
                },
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                xaxis: {
                    categories: products,
                },
                yaxis: {
                    labels: {
                        show: false
                    }
                },
                title: {
                    text: 'Top 10 Products',
                    align: 'center',
                    floating: true
                },
                subtitle: {
                    text: '(Gross Sales Wise in %Percent)',
                    align: 'center',
                },
                tooltip: {
                    theme: 'dark',
                    x: {
                        show: false
                    },
                    y: {
                        title: {
                            formatter: function () {
                                return ''
                            }
                        }
                    }
                }
            };

            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {
            return `<div class="~_topProductContainer"  style="height:250px;  width:350px;" ></div>`;
        }
    }

    export class topBrandschartPanelOptions {
        items: Sales.SalesItemsRow[];
    }

    export class topBrandschartPanel extends Serenity.TemplatedPanel<topBrandschartPanelOptions> {
        constructor(container: JQuery, opt: topBrandschartPanelOptions) {
            super(container, opt);
            var items = opt.items;
            var brands = [];
            var grosssales = [0];
            grosssales.pop();
            for (var i = 0; i < opt.items.length; i++) {
                if (brands.length < 5) {
                    brands.push(opt.items[i].BrandName);
                    grosssales.push(items[i].GrossAmountPercent);
                }
            }
            var options = {
                series: grosssales,
                chart: {
                    type: 'donut',
                },
                title: {
                    text: 'Top Brands',
                    align: 'center',
                    floating: true
                },
                labels: brands,
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            };


            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {

            return `<div class="~_topBrandContainer"  style="height:270px;  width:280px;" ></div>`;
        }
    }

    export class topCollectionschartPanelOptions {
        items: Sales.SalesItemsRow[];
    }

    export class topCollectionschartPanel extends Serenity.TemplatedPanel<topCollectionschartPanelOptions> {
        constructor(container: JQuery, opt: topCollectionschartPanelOptions) {
            super(container, opt);
            var items = opt.items;
            var collections = [];
            var grosssales = [0];
            grosssales.pop();
            for (var i = 0; i < opt.items.length; i++) {
                if (collections.length < 5) {
                    collections.push(opt.items[i].CollectionName);
                    grosssales.push(items[i].GrossAmountPercent);
                }
            }
            var options = {
                series: grosssales,
                chart: {
                    height: 390,
                    type: 'radialBar',
                },
                title: {
                    text: 'Top Collections',
                    align: 'center',
                    floating: true
                },
                plotOptions: {
                    radialBar: {
                        offsetY: 0,
                        startAngle: 0,
                        endAngle: 270,
                        hollow: {
                            margin: 5,
                            size: '30%',
                            background: 'transparent',
                            image: undefined,
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                show: false,
                            }
                        }
                    }
                },
                colors: ['#1ab7ea', '#0084ff', '#39539E', '#0077B5'],
                labels: collections,
                legend: {
                    show: true,
                    floating: true,
                    fontSize: '12px',
                    position: 'left',
                    offsetX: 160,
                    offsetY: 15,
                    labels: {
                        useSeriesColors: true,
                    },
                    markers: {
                        size: 0
                    },
                    formatter: function (seriesName, opts) {
                        return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex]
                    },
                    itemMargin: {
                        vertical: 3
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            show: false
                        }
                    }
                }]
            };

            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {

            return `<div class="~_topBrandContainer"  style="height:270px;  width:280px;" ></div>`;
        }
    }


    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class StoreDetailsDialog extends Serenity.PropertyDialog<any, any>
    {
        //protected form = new StoreDetailForm(this.idPrefix);

        private totalSaleschartPanel: totalSaleschartPanel;

        private topProductchartPanel: topProductchartPanel;

        private topBrandschartPanel: topBrandschartPanel;

        private topCollectionschartPanel: topCollectionschartPanel;       


        private topBrandsGrid: Sales.TopBrandsGrid;
        private topCollectionsGrid: Sales.TopCollectionsGrid;
        private topProductsGrid: Sales.TopProductsGrid;
        constructor() {
            super();
            //this.form = new StoreDetailForm(this.idPrefix);
            this.dialogTitle = "Store Detail";


            this.topProductsGrid = new Sales.TopProductsGrid(this.byId('TopProductsGrid'));
            this.topProductsGrid.openDialogsAsPanel = false;

            this.topBrandsGrid = new Sales.TopBrandsGrid(this.byId('TopBrandsGrid'));
            this.topBrandsGrid.openDialogsAsPanel = false;

            this.topCollectionsGrid = new Sales.TopCollectionsGrid(this.byId('TopCollectionsGrid'));
            this.topCollectionsGrid.openDialogsAsPanel = false;


            q.hideEditorToolbar(this.topProductsGrid);
            q.hideEditorToolbar(this.topBrandsGrid);
            q.hideEditorToolbar(this.topCollectionsGrid);
            this.onViewProcessData();
        }

        getTemplate() {
            return `
<div>
    <div class="TotalSales" style=" display: inline-block; width:450px;
        height:250px;">

    </div>
    <div class="TopProducts" style=" display: inline-block; width:350px;
        height:250px;">

    </div>
<div class="TopBrands" style=" display: inline-block; width:280px;
        height:270px;">

    </div>
<div class="TopCollections" style=" display: inline-block; width:270px;
        height:280px;">

    </div>
</div>
<div>
    <div id="~_TopProductsGrid" style=" display: inline-block;
        width:450px;
        height:500px;">
    </div>
    <div id="~_TopBrandsGrid" style="  display: inline-block;
        width:450px;
        height:500px;">
    </div>
    <div id="~_TopCollectionsGrid" style="  display: inline-block;
        width:450px;
        height:500px;">
    </div>
</div>`
        }
        getDialogOptions() {
            let opt = super.getDialogOptions();

            opt.width = 1280;
            return opt
        }
        protected onDialogOpen() {
            jQuery(".ui-dialog-titlebar-maximize").click();
            super.onDialogOpen();

        }
        onViewProcessData() {
            var self = this;

            if (this.totalSaleschartPanel) {
                this.totalSaleschartPanel.destroy();
            }
            Sales.CustomerSalesService.TotalSalesList({}, response => {
                self.totalSaleschartPanel = new totalSaleschartPanel(this.element.find(".TotalSales"), { items: response.Entities });
            }, { async: false });

            if (this.topProductchartPanel) {
                this.topProductchartPanel.destroy();
            }
            Sales.TopProductsService.List({}, response => {
                self.topProductchartPanel = new topProductchartPanel(this.element.find(".TopProducts"), { items: response.Entities });
            }, { async: false });


            if (this.topBrandschartPanel) {
                this.topBrandschartPanel.destroy();
            }
            Sales.TopBrandsService.List({}, response => {
                self.topBrandschartPanel = new topBrandschartPanel(this.element.find(".TopBrands"), { items: response.Entities });
            }, { async: false })

            if (this.topCollectionschartPanel) {
                this.topCollectionschartPanel.destroy();
            }
            Sales.TopCollectionsService.List({}, response => {
                self.topCollectionschartPanel = new topCollectionschartPanel(this.element.find(".TopCollections"), { items: response.Entities });
            }, { async: false })



            return null;
        }

    }
}